module.exports = "\n.top-link-block {\n    z-index: 0;\n  }\n\nbody{\n  overscroll-behavior: contain;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main